import React from "react";
import Header from "../../components/HeaderGreen";
import Footer from "../../components/Footer";
import AboutBanner from "../../components/AboutBanner";
import ContactSection from "../../components/ContactSection";
import Whychoose from "../../components/Projects/Whychoose";
import WorkHighlights from "../../components/Projects/WorkHighlights";

function Home() {
  return (
    <>
      <Header />
      <AboutBanner
  title="Successful project"
  subtitle="☀️ CM Green Energy India Private Limited"
/>
      <WorkHighlights />
      <Whychoose />
      <ContactSection />
      <Footer /> 
    </>
  );
}

export default Home;
